/**
 * Subscription plans (catalog) API: list of plans to purchase. Used by SubscriptionListScreen.
 */
import { apiGet } from '../../../shared/api/client';
import { endpoints } from '../../../shared/config/endpoints';

export interface SubscriptionPlanCategory {
  id?: number | string;
  type?: string;
  title?: string;
  description?: string;
  attachment?: string;
  thumbnail?: string;
  subscriptions?: Array<{
    id?: number;
    subscription_id?: number;
    days?: number;
    type_key?: number;
    duration?: number;
    type_data?: any[];
    [key: string]: unknown;
  }>;
  particulars?: any[];
  [key: string]: unknown;
}

export interface CatalogSubscriptionPlansResponse {
  success?: boolean;
  data?: {
    subscription_categories?: SubscriptionPlanCategory[];
    subscriptions?: SubscriptionPlanCategory[];
    [key: string]: unknown;
  };
}

/**
 * Fetch subscription plans (catalog). Optional query params for filters (e.g. calories, type).
 */
export async function fetchSubscriptionPlans(params?: { calories?: number; type?: string }): Promise<SubscriptionPlanCategory[]> {
  const query: Record<string, string | number> = {};
  if (params?.calories != null) {
    query.calories = params.calories;
  }
  if (params?.type != null) {
    query.type = params.type;
  }

  const res = await apiGet<CatalogSubscriptionPlansResponse>(endpoints.subscriptions, Object.keys(query).length > 0 ? query : undefined);
  const data = res?.data;
  const categories = data?.subscription_categories ?? data?.subscriptions;
  return Array.isArray(categories) ? categories : [];
}
